module.exports = __webpack_public_path__ + "afc9b40e5ca1c73295318610dd0a511c.jpg";